/* eslint-disable eslint-comments/disable-enable-pair */
import React from 'react';

import { Button, Colors } from '../legacy/button/Button.component';
import styles from './FinancedByMogul.module.css';

export interface FinancedMovieData {
  image: string;
  title: string;
  studio: string;
  viewOnClick: () => void;
}
interface Props {
  movies: FinancedMovieData[];
  movieIds: string[];
  handleViewOnClick: (movieId: string) => void;
}

export const FinancedByMogul: React.FC<Props> = props => {
  const moviesToShow = props.movies.map((movie, i) => {
    return (
      <div
        key={movie.title + i.toString()}
        className={
          'rounded-lg flex flex-col justify-between ' +
          (props.movies.length % 2 === 0 || props.movies.length === 1
            ? styles.movieBackground
            : styles.movieBackgroundOdd +
              ' 2xl:w-72 xl:w-60 lg:w-52 w-full bg-gradient-to-r ') +
          ' bg-gradient-to-r'
        }
        style={{
          backgroundColor: '#161a27',
          backgroundImage:
            `${
              props.movies.length % 2 === 0 || props.movies.length === 1
                ? 'linear-gradient(to bottom,rgba(255,255,255,0.01) 0%, rgba(0,0,0,0.1) 50%, #161a27 80%), '
                : 'linear-gradient(to bottom,rgba(255,255,255,0.01) 0%, rgba(0,0,0,0.1) 50%, #161a27 75%), '
            }` +
            'url("' +
            movie.image +
            '")',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center top',
        }}
      >
        <div className="flex items-end justify-end"></div>
        <div className="h-56 flex flex-col justify-end px-3 pb-3">
          <div className={styles.movieTitle + ' uppercase mb-3'}>
            {movie.title}
          </div>
          <div className={styles.studio}>{movie.studio}</div>
          <div className="flex">
            <div className="flex w-full">
              <Button
                className={'flex w-full h-10'}
                color={Colors.COLOR_SCHEME_6}
                onClick={() => {
                  props.handleViewOnClick(props.movieIds[i]);
                }}
              >
                VIEW DETAILS
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  });
  return (
    <div
      className={`flex flex-wrap ${
        moviesToShow.length === 1 ? 'justify-start' : 'justify-center'
      } gap-10`}
    >
      {moviesToShow}
    </div>
  );
};
